import { TwoFactorType } from "@enum/two-factor-type.enum";

export class TwoFactorCurrentMethodModel
{
    method_type: TwoFactorType | null;
    is_verified: boolean;
    is_authenticated: boolean;
}

/**
 * O segundo fator está satisfeito para esta sessão?
 *
 * SEGUNDO FATOR OPT-IN (decisão do dono, 02/09/2026). O segundo fator passou a
 * ser opcional: quem não tem fator cadastrado entra normalmente, quem TEM
 * continua obrigado a passar por ele. Este é o predicado que traduz isso, e ele
 * é o espelho exato de `TwoFactorService::isSatisfied()` da API — o portão do
 * middleware `two_factor`. Os dois lados TÊM de concordar: se divergissem, o
 * client liberaria a navegação e a API responderia 401 na requisição seguinte.
 *
 * Os dois campos vêm de `GET two-factor/current-method`
 * (`TwoFactorController::currentMethod`) e significam coisas diferentes:
 *
 *  - `is_verified` — existe ao menos um fator VERIFICADO, em qualquer sessão
 *    (`hasSomeTwoFactorAuthenticated()`). É o "tem 2FA cadastrado";
 *  - `is_authenticated` — o fator foi satisfeito NESTA sessão
 *    (`isAuthenticated()`, com o id do token). É o "passou pelo 2FA agora".
 *
 * Logo: `is_verified === false` significa "não há segundo fator a passar", e
 * libera. **O que NÃO libera, e é o alvo de segurança de toda esta mudança:**
 * `is_verified === true` com `is_authenticated === false` — 2FA cadastrado e
 * sessão que ainda não passou por ele. Falso-allow ali é o defeito caro.
 *
 * `null` é estado DESCONHECIDO — o método corrente ainda não carregou, ou o
 * usuário não está logado e `current-method` respondeu 401. Nega, porque
 * desconhecido não é "não tem".
 */
export function segundoFatorSatisfeito(metodo: TwoFactorCurrentMethodModel | null | undefined): boolean {
  if (metodo == null) {
    return false;
  }

  return metodo.is_authenticated === true || metodo.is_verified === false;
}
